<template>
    <div class="division-management">
        部门管理
    </div>
</template>

<script>
    export default {
        name: "division-management"
    }
</script>

<style scoped>

</style>